// Layout constants for the global "New call" launcher FAB (TwilioVoiceProvider). Shared so pages
// that scroll under it can reserve matching bottom space instead of hard-coding the numbers.
export const VOICE_FAB_SIZE = 48; // MUI <Fab size="medium">
export const VOICE_FAB_RIGHT = { xs: 16, md: 24 };
export const VOICE_FAB_BOTTOM = { xs: 18, md: 24 };
export const VOICE_FAB_CLEARANCE = 16; // breathing room between the last content and the FAB

// Bottom padding (px) that lets the end of a page scroll fully clear of the FAB. Uses the larger
// (desktop) offset at every width — a few extra px on mobile is harmless and avoids a media query.
export const VOICE_FAB_SAFE_BOTTOM = Math.max(VOICE_FAB_BOTTOM.xs, VOICE_FAB_BOTTOM.md) + VOICE_FAB_SIZE + VOICE_FAB_CLEARANCE;
